import { render, staticRenderFns } from "./MailingUnsubscribed.vue?vue&type=template&id=4e95870d&"
import script from "./MailingUnsubscribed.vue?vue&type=script&lang=ts&"
export * from "./MailingUnsubscribed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports